import { createContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "./components/Layout";
import Search from "./pages/Search/Search";
import Home from "./pages/Home";
import ResultDetail from "./pages/ResultDetail";
import NotFound from "./pages/NotFound";
import GuidedSearch from "./pages/GuidedSearch";
import FAQ from "./pages/FAQ";
import About from "./pages/About";
import Compare from "./pages/Compare";
import SurveyPrompt from "./components/SurveyPrompt";
import { useIdleMonitor } from "./utils/idleMonitor";
import N988line from "./pages/n988line";


/* call for all lookup tables
https://api.dev.profile.cocaredirectory.com/v1/lookup-tables?language=en&IncludeAccessibilitySupports=true&IncludeCareSettings=true&IncludeLanguages=true&IncludePatientAgeGroups=true&IncludePatientCommunities=true&IncludePaymentTypes=true&IncludeRaes=true&IncludeServiceCategories=true&IncludeServicesProvided=true&IncludeTelehealthOptions=true
*/

const TRIGGER_EVENT_THRESHOLD = 2;

export const SurveyTriggerContext = createContext<{
  incrementTriggerEventCount: () => void;
}>({ incrementTriggerEventCount: () => { } });

function App() {

  const { t } = useTranslation();

  // useEffect(() => {
  //   document.title = t("title");
  // });

  useIdleMonitor();

  const [_, setCount] = useState(0);
  const [shouldShowSurvey, setShouldShowSurvey] = useState(false);

  return (
    <main className="App">
      <SurveyTriggerContext.Provider
        value={{
          incrementTriggerEventCount: () => {
            setCount((count) => {
              if (count === TRIGGER_EVENT_THRESHOLD - 1)
                setShouldShowSurvey(true);
              return count + 1;
            });
          },
        }}
      >

        <SurveyPrompt
          shouldShowSurvey={shouldShowSurvey}
        />
      {/* <PupDataProvider searchFilters={searchFilters}> */}
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="search" element={<Search />} />
            <Route path="guided-search" element={<GuidedSearch />} />
            <Route path="result/:resultId" element={<ResultDetail />} />
            <Route path="result/988-line" element={<N988line />} />
            <Route path="compare" element={<Compare />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="about" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        {/* </PupDataProvider> */}
      </SurveyTriggerContext.Provider>
    </main>
  );
}

export default App;
